import { render, staticRenderFns } from "./TestimonialThree.vue?vue&type=template&id=46ca7c9f&scoped=true&"
import script from "./TestimonialThree.vue?vue&type=script&lang=js&"
export * from "./TestimonialThree.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialThree.vue?vue&type=style&index=0&id=46ca7c9f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ca7c9f",
  null
  
)

export default component.exports